import firebase from "../../firebase";

const INVALID_FIREBASE_KEY_CHARACTERS = /[.#$[\]/]/;

const COLLECTIONS_BY_KIND = {
    playlist: {
        collection: "playlists",
        infoCollection: "playlistinfo",
    },
    timeline: {
        collection: "timelines",
        infoCollection: "timelineinfo",
    },
};

export async function deletePlaylistOrTimelineRecord(kind, itemKey) {
    const collections = COLLECTIONS_BY_KIND[kind];

    if (!collections) {
        throw new Error("A valid playlist or timeline kind is required.");
    }

    if (
        typeof itemKey !== "string" ||
        itemKey.trim() === "" ||
        INVALID_FIREBASE_KEY_CHARACTERS.test(itemKey)
    ) {
        throw new Error(
            `A valid Firebase ${kind} key is required for deletion.`,
        );
    }

    await firebase.database().ref().update({
        [`${collections.collection}/${itemKey}`]: null,
        [`${collections.infoCollection}/${itemKey}`]: null,
        [`notifications/${itemKey}`]: null,
    });
}
